/** Tags which uniquely identify the user, potentially across multiple sessions. */
export enum TelemetryUserTags {
  /** The unique identifier for the entire session with the customer. */
  customerId = "customerId"
}

/** Tags which apply universally to a single session. */
export enum TelemetrySessionTags {
  /** The unique identifier for the entire session with the customer. */
  ContactId = "contactId",
  /** The unique identifier for the customer entity assigned to the session. */
  CustomerId = "customerId",
  /** The tag which will uniquely identify the session by the 6-character key used to start the session. */
  SessionKey = "sessionKey",
  /** A tag used when the user experiences the scheduling step loader at least once. */
  SchedulingStepLoading = "schedulingStepLoading"
}
